/**
* Created by Dixi Gu on 2021/4/22.
*/
<template>
  <div>
    <a-card :bordered="false"
            v-if="adminLevel !=='school'">
      <a-tabs
        v-model="currentPaneKey"
        @tabClick="onTabClick">
        <a-tab-pane tab="预约人数设置" key="1">
          <a-select
            v-model="signupId"
            size="large"
            placeholder="请选择报名"
            style="width: 180px;margin-right: 10px"
          >
            <a-select-option
              v-for="item of signupList"
              :value="item.signupNoticeId"
            >{{item.title}}</a-select-option>
          </a-select>
          <a-select
            allowClear
            :dropdownMatchSelectWidth="false"
            :notFoundContent="'暂无数据！'"
            v-model="schoolId"
            size="large"
            style="width: 180px;margin-right: 10px"
            placeholder="请选择幼儿园"
          >
            <a-select-option v-for="item of schoolList" :value="item.id">{{item.name}}</a-select-option>
          </a-select>
          <a-select
            allowClear
            v-model="state"
            size="large"
            placeholder="设置状态"
            style="width: 180px;margin-right: 10px"
          >
            <a-select-option :value="0">未设置</a-select-option>
            <a-select-option :value="1">已设置</a-select-option>
          </a-select>
          <a-button type="primary"  size="large" icon="search" @click="getSchoolSettingList">
            搜 索
          </a-button>

          <a-table :pagination="false" :data-source="tableData" style="margin-top: 10px">
            <a-table-column title="序号" data-index="index" />
            <a-table-column title="幼儿园" data-index="schoolName" />
            <a-table-column title="设置状态" data-index="setState">
              <template v-slot="text, record">
                {{text===0?'未设置':'已设置'}}
              </template>
            </a-table-column>
            <a-table-column title="操作">
              <template v-slot="text, record">
                <a-button type="link" @click="onTabClick('2',record.id)">查看</a-button>
              </template>
            </a-table-column>
          </a-table>
          <div style="margin-top: 10px">
            <a-pagination
              style="float: right"
              show-size-changer
              v-model="page.page"
              :page-size.sync="page.size"
              :total="page.total"
              @change="handlePageChange"
              @showSizeChange="handlePageChange"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane tab="查看报名" disabled key="2">
          <a-form v-if="detailObj">
            <a-form-item  label="当前报名计划" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
              {{detailObj.title}}
            </a-form-item>
            <a-form-item  label="预约时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
              <div>
              {{detailObj.reserveBegin}}~{{detailObj.reserveEnd}}
              </div>
              <div>
                上午：{{detailObj.amBegin}}~{{detailObj.amEnd}}
              </div>
              <div>
                下午：{{detailObj.pmBegin}}~{{detailObj.pmEnd}}
              </div>
            </a-form-item>
            <a-form-item  label="预约人数" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
              <a-table :data-source="detailObj.signupQuotaDomains" :pagination="false">
                <a-table-column title="预约日期" data-index="quotaDate"></a-table-column>
                <a-table-column title="上 / 下午" data-index="amPmType">
                  <template v-slot="text,record">
                    {{text===2?'下午':text===0?'全天':'上午'}}
                  </template>
                </a-table-column>
                <a-table-column title="预约人数" data-index="limitNum"></a-table-column>
              </a-table>
            </a-form-item>

          </a-form>

        </a-tab-pane>
      </a-tabs>

    </a-card>

    <a-card v-else :bordered="false" title="预约人数设置">
      <a-form>
        <a-form-item  label="当前报名计划" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
          <a-select
            v-model="signupId"
            size="large"
            placeholder="请选择报名"
            style="width: 180px;margin-right: 10px"
            @change=" getDetailById"
          >
            <a-select-option
              v-for="item of signupList"
              :value="item.signupNoticeId"
            >{{item.title}}</a-select-option>
          </a-select>
        </a-form-item>
        <template v-if="detailObj">
          <a-form-item  label="预约时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
            <div>
              {{detailObj.reserveBegin}}~{{detailObj.reserveEnd}}
            </div>
            <div>
              上午：{{detailObj.amBegin}}~{{detailObj.amEnd}}
            </div>
            <div>
              下午：{{detailObj.pmBegin}}~{{detailObj.pmEnd}}
            </div>
          </a-form-item>
          <a-form-item  label="预约人数" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
            <div v-for="item in detailObj.signupQuotaDomains">
              <a-date-picker
                disabled
                v-model="item.quotaDate"
              />
              <a-select style="width: 100px;" disabled v-model="item.amPmType">
                <a-select-option :value="1">上午</a-select-option>
                <a-select-option :value="2">下午</a-select-option>
              </a-select>
              <a-input-number :min="0" :precision="0" v-model="item.limitNum"></a-input-number>
            </div>
          </a-form-item>
        </template>
      </a-form>
      <div style="text-align: center">
        <a-button type="primary" @click="handlerSave">保存</a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
		mixins: [],
		props: [],
		components: {},
		data() {
			return {
        currentPaneKey:'1',
        adminLevel: this.$store.state.adminLevel,
        studentType: this.$store.state.systemLevel === 'kinder' ? 1 : (this.$store.state.systemLevel === 'school' ? 2 : 0),
        schoolList: [],
        tableData: [],
        signupList: [],
        signupId: undefined,
        schoolId: undefined,
        state: undefined,
        page:{
          "page":1,
          "size": 10,
          total:0
        },

        detailObj:null,
        signup:null,
        signupLimitList:[]
      };
		},
		async created() {
		  await this.ajaxGetSignupList()
		  await this.getSchoolSettingList()
		},
		mounted() {
		},
		computed: {

    },
		methods: {
      onTabClick(key,id) {
        if (this.currentPaneKey == key) return;

        this.currentPaneKey = key;
        if(key === '1'){
          this.detailObj = null
          return
        }

        this.getDetailById(id)
      },
      handlePageChange(page, pageSize){
        this.page.page = page
        this.page.size = pageSize
        this.getSchoolSettingList()
      },
      async ajaxGetSignupList() {
        let {data} = await this.$ajax.gateway("/bm-kids/ISignupNoticeApi_querySignupNotices", {
          studentType: this.studentType
        })
        // 处理获取的报名列表数据
        if (data.code===200) {
          data = data.data
          if (typeof data === "object" && data.length > 0) {
            this.signupList = data;
            this.signupId = this.signupList[0].signupNoticeId
            this.signup = this.signupList[0]

            let days = this.duration(this.signup.signupBegin,this.signup.signupEnd)
            for(let i=0;i<days;i++){
              this.signupLimitList.push({
                quotaDate: moment(this.signup.signupBegin).add(i, 'd').format('YYYY-MM-DD'),
                amPmType: 1,
                limitNum:0
              })
              this.signupLimitList.push({
                quotaDate: moment(this.signup.signupBegin).add(i, 'd').format('YYYY-MM-DD'),
                amPmType: 2,
                limitNum:0
              })
            }
          }
        }

        // 获取通知id后获取幼儿园列表
        if(this.adminLevel !=='school'){
          this.getKinderSchoolData();
        }else{
          this.getDetailById(data[0].signupNoticeId)
        }
      },
      duration(start,end){
        return moment.duration(moment(end) - moment(start)).asDays();
      },
      async getKinderSchoolData(params) {
        let { data } = await this.fetchKinderSchool(params);
        this.schoolList = data;
      },
      // 获取幼儿园列表
      async fetchKinderSchool(args) {
        let signupNoticeId = this.signupId;
        if(!signupNoticeId) return this.$message.error('还未创建报名活动！');

        // 报名端-根据街道CODE查询幼儿园列表 #李茹钰/2020-06-02#
        let {data,error} = await this.$ajax.gateway("/bm-kids/ISchoolApi_searchSchoolByAreaCode_1", {
          "METHOD": "get",
          signupNoticeId,
        });

        if (data) {
          return data;
        } else {
          this.$message.error('获取学校列表失败！');
          return { data: null };
        }
      },
      async getSchoolSettingList(){
        if(!this.signupId) return
        // 根据报名通知ID查询幼儿园列表 #敬瑞/2021-04-21#
        let {data} = await this.$ajax.gateway("/bm-kids/ISchoolSignupApi_list", {
          "body": {
            "pageableDto": this.page,
            "schoolId": this.schoolId,
            "setState": this.state,
            "signupNoticeId": this.signupId
          }
        });
        data = data.data
        this.tableData = data.dataList.map((item,index)=>{
          return {
            ...item,
            index:index+1
          }
        })
        this.page.total = data.totalCount
      },
      async getDetailById(id){
        // 根据报名通知ID查询幼儿园人数设置信息 #敬瑞/2021-04-22#
        let {data} = await this.$ajax.gateway("/bm-kids/ISchoolSignupApi_detail", {
          "METHOD": "get",
          "id": id
        });
        this.detailObj = data.data
      },
      async handlerSave(){
        // 根据报名通知ID查询幼儿园人数设置信息 #敬瑞/2021-04-22#
        let {data} = await this.$ajax.gateway("/bm-kids/ISchoolSignupApi_detail_1", {
          "id": this.signupId,
          "body": {
            "quotas": this.detailObj.signupQuotaDomains
          }
        });
        if(data.code===200){
          this.$message.success('保存成功！')
        }
      }
    }
	};
</script>
<style lang="stylus" scoped>
</style>